(function () {
  function slugify(text, index) {
    var slug = text
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || 'section-' + index;
  }

  function disableToc(root, toc) {
    var shell = root.querySelector('[data-cofier-guide-shell]');
    var sidebar = root.querySelector('[data-cofier-sidebar]');

    if (toc) {
      toc.setAttribute('hidden', '');
    }

    if (sidebar) {
      sidebar.setAttribute('hidden', '');
    }

    if (shell) {
      shell.classList.add('cofier-blog-guide__shell--no-sidebar');
    }
  }

  function initGuide(root) {
    var content = root.querySelector('[data-cofier-article-content]');
    var toc = root.querySelector('[data-cofier-toc]');

    if (!content || !toc) {
      disableToc(root, toc);
      return;
    }

    var includeH3 = root.getAttribute('data-include-h3') === 'true';
    var selector = includeH3 ? 'h2, h3' : 'h2';
    var headings = Array.prototype.slice.call(content.querySelectorAll(selector));

    headings = headings.filter(function (heading) {
      return heading.textContent.trim().length > 0;
    });

    if (headings.length < 2) {
      disableToc(root, toc);
      return;
    }

    var usedIds = {};
    var list = toc.querySelector('[data-cofier-toc-list]');
    if (!list) return;

    list.innerHTML = '';

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var baseId = slugify(heading.textContent, index + 1);
        var id = baseId;
        var count = 2;

        while (usedIds[id] || document.getElementById(id)) {
          id = baseId + '-' + count;
          count += 1;
        }

        heading.id = id;
      }

      usedIds[heading.id] = true;

      var item = document.createElement('li');
      item.className = 'cofier-blog-toc__item cofier-blog-toc__item--' + heading.tagName.toLowerCase();

      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();

      item.appendChild(link);
      list.appendChild(item);
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-cofier-blog-guide]')).forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();